<script lang="ts">
  import { session } from '$lib/state/session.svelte';
  import { customerCategory, intakeTeams, intakeTeamLabel, type CustomerCategory } from '$lib/utils/customerIntake';

  let { verticalId = $bindable(undefined), onChange, idPrefix = 'customer-intake' }: {
    verticalId: number | undefined;
    onChange?: () => void;
    idPrefix?: string;
  } = $props();
  const teams = $derived(session.me?.verticals ?? []);
  const category = $derived(customerCategory(teams, verticalId));
  const choices = $derived(intakeTeams(teams, category));
  function changeCategory(value: CustomerCategory) {
    const candidates = intakeTeams(teams, value);
    if (!candidates.length) return;
    verticalId = candidates[0].id;
    onChange?.();
  }
</script>

<div class="space-y-2">
  <label class="label" for={`${idPrefix}-category`}>Customer category</label>
  <select id={`${idPrefix}-category`} class="input" value={category} onchange={event => changeCategory(event.currentTarget.value as CustomerCategory)}>
    <option value="hotel" disabled={!intakeTeams(teams, 'hotel').length}>Hotel</option>
    <option value="non_hotel" disabled={!intakeTeams(teams, 'non_hotel').length}>Non-hotel</option>
  </select>
  <p class="text-xs text-dark-gray">{category === 'hotel' ? 'Hotel coordination: Anitha.' : 'Non-hotel coordination: Farhath.'} Coordination is separate from sales ownership and does not grant access to other teams.</p>
  <label class="label" for={`${idPrefix}-team`}>{category === 'hotel' ? 'Hotel team' : 'Responsible sales team'}</label>
  <select id={`${idPrefix}-team`} class="input" bind:value={verticalId} onchange={() => onChange?.()} required>
    <option value={undefined} disabled>Choose a team</option>
    {#each choices as team (team.id)}<option value={team.id}>{intakeTeamLabel(team)}</option>{/each}
  </select>
  <p class="text-xs text-dark-gray">Team names identify who handles the work—not the company type. Only your permitted teams are available.</p>
</div>
